import { isXlApp } from '@/utils/judgeEnv';
import { callApp } from '@/utils';

/**
 * 监听回到页面
 * @param cb
 */
function listenPageVisible(cb) {
  document.addEventListener('visibilitychange', function onVisibilitychange() {
    if (document.visibilityState === 'visible') {
      document.removeEventListener('visibilitychange', onVisibilitychange);
      cb && cb();
    }
  });
}

export function goBackWhileReturn() {
  listenPageVisible(() => {
    if (window.history.length > 1) {
      window.history.go(-1);
      return;
    }
    if (isXlApp()) {
      callApp(
        JSON.stringify({
          action: 'closeWebView'
        })
      );
    }
  });
}
